const aaa = [
	
	{
		path: "goods",
		component: () => import("@/views/chanpin/goods/goods.vue"),
		meta:{title:'商品'},
	},
	{
		path: "addgoods",
		component: () => import("@/views/chanpin/goods/addgoods.vue"),
		meta:{title:'编辑商品'},
	},
]
export default aaa;